import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { IHttpClient } from "../interfaces/IHttpClient";
import { LoggerService } from "../services/logs/logger.service";
import { HttpResponse } from "./httpResponse";

@Injectable({
    providedIn: "root",
})
export class AngularHttpClient implements IHttpClient {
    constructor(protected logger: LoggerService,
                protected httpClient: HttpClient) {
    }

    public async delete(url: string, headers: any): Promise<HttpResponse> {
        let response = await firstValueFrom(this.httpClient.delete(url, {
            headers: new HttpHeaders(headers),
            observe: "response",
        }));

        this.logger.debug(this.constructor.name, "🌐 Http DELETE call to : " + url, response);

        return new HttpResponse(response.status, response.body, this.headersToMap(response.headers));
    }

    public async get(url: string, headers: any): Promise<HttpResponse> {
        let response = await firstValueFrom(this.httpClient.get(url, {
            headers: new HttpHeaders(headers),
            observe: "response",
        }));

        this.logger.debug(this.constructor.name, "🌐 Http GET call to : " + url, response);

        return new HttpResponse(response.status, response.body, this.headersToMap(response.headers));
    }

    public async post(url: string, headers: any, data: any): Promise<HttpResponse> {
        let response = await firstValueFrom(this.httpClient.post(url, data, {
            headers: new HttpHeaders(headers),
            observe: "response",
        }));

        this.logger.debug(this.constructor.name, "🌐 Http POST call to : " + url, data, response);

        return new HttpResponse(response.status, response.body, this.headersToMap(response.headers));
    }

    public async put(url: string, headers: any, data: any): Promise<HttpResponse> {
        let response = await firstValueFrom(this.httpClient.put(url, data, {
            headers: new HttpHeaders(headers),
            observe: "response",
        }));

        this.logger.debug(this.constructor.name, "🌐 Http PUT call to : " + url, data, response);

        return new HttpResponse(response.status, response.body, this.headersToMap(response.headers));
    }

    private headersToMap(headers: HttpHeaders) {
        let result = new Map<string, string>();

        headers.keys().forEach(key => {
            result.set(key, headers.get(key));
        });

        return result;
    }
}
